<template>
  <div class="banner">
    <a-carousel autoplay>
      <div v-for="item in banner" :key="item">
        <el-image
          style="vertical-align: middle"
          :alt="item.slogan"
          class="banner-img"
          :src="item.url"
        />
      </div>
    </a-carousel>
    <div class="track-card">
      <el-input
        ref="saveTagInput"
        v-model="inputValue"
        class="input-new-tag"
        type="textarea"
        :rows="3"
        placeholder="请输入单号，多个单号以;分隔，最多20个单号"
      >
      </el-input>
      <el-button
        type="primary"
        style="width: 200px; margin-left: 20px; bottom: 0"
        @click="search()"
        >轨迹查询
      </el-button>
    </div>
  </div>
</template>

<script>
import HomeApi from '../../network/home'
import { program_type, content_type } from '../../common/enum/imgEnum'

export default {
  name: 'Banner',
  data() {
    return {
      imgIndex: 1,
      height: '',
      banner: [
        // require('@/assets/images/banner/banner5.jpg'),
        // require('@/assets/images/banner/banner6.jpg')
      ],
      inputValue: ''
    }
  },
  async created() {
    await this._selectBanner()
  },
  mounted() {
    this.setSize1()
    const that = this
    // 监听浏览器窗口大小改变
    window.addEventListener(
      'resize',
      function () {
        const width =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
        that.screenWidth = width
        that.setSize()
      },
      false
    )
  },
  methods: {
    async _selectBanner() {
      const result = await HomeApi.getContent(
        program_type.common,
        content_type.banner
      )
      this.banner = result.data
    },
    search() {
      const u = this.inputValue.toString().replace(/[\n\r]/g, ';')
      const f = u.toString().replace(/；/g, ';')
      const url = 'http://39.108.216.104:5001/#/tracking?no=' + f
      window.open(url, '_blank')
    },
    setSize1() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
      this.screenWidth = width
      // 图片                高 / 宽  700 / 1920
      this.bannerHeight = (960 / 1920) * this.screenWidth - 50
      document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
    },
    setSize() {
      this.bannerHeight = (960 / 1920) * this.screenWidth - 50
      document.getElementById('el-carousel').style.height =
        this.bannerHeight + 'px'
    }
  }
}
</script>

<style scoped>
.banner {
  position: relative;
}

.banner-img > img {
  vertical-align: middle;
}

.track-card {
  padding: 20px;
  border-radius: 7px;
  height: 80px;
  border: none;
  background-color: rgba(37, 37, 37, 0.5);
  z-index: 10;
  position: fixed;
  width: 100%;
  bottom: 0;
  display: flex;
  justify-content: center;
}

.input-new-tag {
  width: 400px;
  height: 40px;
}

.carousel {
  width: 100%;
}

.el-carousel__container {
  /*height: 456px;*/
  height: 100% !important;
}
</style>
